import * as envalid from 'envalid';

const { APP_ENV } = process.env;
import { cleanEnv, makeValidator } from 'envalid';

const containHttps = makeValidator((x) => {
  if (!x) return 'Missing value';
  if (/^https:\/\//.test(x) || APP_ENV === 'dev') return '';
  return 'Expected https url';
});

const string = makeValidator((x) => {
  if (!x) return 'Missing value';
  if (x && typeof x === 'string') return '';
  return 'Expected string';
});

export const checkEnv = () => {
  let e = [];
  const env = cleanEnv(
    process.env,
    {
      APP_ENV: makeValidator((x) => {
        if (['dev', 'qa', 'prod'].includes(x)) return '';
        return 'Expected value must be dev | qa | prod';
      })(),
      API_KEY: string(),
      API_SECRET: string(),
      API_CLIENT_ID: string(),
      GOOGLE_API_KEY: string(),
      API_BASE_URL: containHttps(),
      API_SSO_URL: containHttps(),
      API_IRS_URL: containHttps(),
      ENABLED_COMPONENTS: makeValidator((x) => {
        if (['all', 'customer'].includes(x)) return '';
        return 'Expected value must be all | customer';
      })(),
      SSO_MANAGEMENT_ONLY: makeValidator((x) => {
        if (['false', 'true'].includes(x)) return '';
        return 'Expected boolean';
      })(),
    },
    {
      reporter: ({ errors }) => {
        e = errors;
      },
    },
  );

  const envMessage = Object.entries(env).reduce(
    (acc, [key, value]) => ({ ...acc, [key]: value }),
    {},
  );

  for (const [envVar, err] of Object.entries(e)) {
    if (err instanceof envalid.EnvMissingError) {
      envMessage[envVar] = 'Missing value';
    }
  }
  return envMessage;
};
